import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { baseURL, zlink } from "service/HttpService";
import { useDispatch } from "react-redux";
import { getPdfDrawing } from 'redux/pages/AsBuilts/AsBuiltsSlice';

interface DocumentViewerPropType {
    showModal: boolean;
    setShowModal: (state: boolean) => void;
    fileName?: string;
    setFileName: (state: any) => void;
    drawingId?: any;
    revisionNumber?:any;

}
const PdfDrawingViewer: React.FC<DocumentViewerPropType> = ({
    showModal = false,
    setShowModal = () => { },
    fileName = "",
    setFileName = () => { },
    drawingId = "",
    revisionNumber=""
}) => {
    const [reportUrl, setReportUrl] = useState<string | null>(null);
    const dispatch = useDispatch<any>();
   
    useEffect(() => {
        dispatch(getPdfDrawing(drawingId, revisionNumber, setReportUrl));
        return () => {           
            setReportUrl(null);
        };
    }, [showModal, drawingId, revisionNumber]);
    return (
        <div>
            <Dialog
                header={<span title={`${fileName}`}>View Drawing ({fileName})</span>}
                visible={showModal}
                style={{ width: "75vw", height: "85%" }}
                onHide={() => {
                    setShowModal(false);
                    setFileName('');
                }}
                className="view-file-modal">
                <div className="content-box">
                    <div className='file-content'>
                        {(reportUrl) ?
                            <object data={reportUrl} title={fileName} type="application/pdf" width="100%" height="100%" ></object>
                            :
                            (<></>)
                        }
                    </div>
                </div>
            </Dialog>
        </div>
    )
}
export default PdfDrawingViewer;